import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const getStoredSupplierCode = () => {
  const stored = localStorage.getItem("currentUser");
  return stored ? stored.trim() : "";
};

const Forecast = () => {
  const currentMonthIndex = new Date().getMonth();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const shortMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const blankInputs = months.reduce((acc, month) => ({ ...acc, [month]: "" }), {});

  const [inputData, setInputData] = useState(blankInputs);
  const [originalData, setOriginalData] = useState(blankInputs);
  const [isSaving, setIsSaving] = useState(false);
  const [supplierCode, setSupplierCode] = useState(getStoredSupplierCode());

  useEffect(() => {
    const handleSupplierChange = (event) => {
      const next = event?.detail?.supplier?.trim() || getStoredSupplierCode();
      setSupplierCode(next);
    };

    window.addEventListener("supplierContextChanged", handleSupplierChange);
    return () => {
      window.removeEventListener("supplierContextChanged", handleSupplierChange);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!supplierCode) {
        return;
      }
      try {
        const supplierId = supplierCode.replace(/\s/g, "");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/api/forecast/${supplierId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const nextValues = { ...blankInputs };
        data.forEach((item) => {
          const monthAbbr = item.Month?.trim();
          const value = item.Value;
          const monthIndex = shortMonths.indexOf(monthAbbr);
          if (monthIndex !== -1) {
            const fullMonth = months[monthIndex];
            nextValues[fullMonth] = value !== null ? String(value) : "";
          }
        });

        setInputData(nextValues);
        setOriginalData(nextValues);
      } catch (error) {
        console.error("Error fetching forecast:", error);
        toast.error("Unable to load forecast data");
      }
    };

    fetchData();
  }, [supplierCode]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value === "" ? "" : value,
    }));
  };

  const handleReset = () => {
    setInputData(originalData);
  };

  const handleSaveClick = async () => {
    if (!supplierCode) {
      toast.error("No supplier selected", { position: "top-center" });
      return;
    }
    try {
      setIsSaving(true);
      const currentYear = new Date().getFullYear();
      const supplierId = supplierCode.replace(/\s/g, "");

      const activeMonthData = months
        .filter((month) => inputData[month] !== "" && inputData[month] !== undefined)
        .map((month) => ({
          month,
          value: parseInt(inputData[month], 10),
        }));

      const payload = {
        year: currentYear,
        month: activeMonthData,
        supplier: supplierId,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASEURL}/api/forecast`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Forecast saved successfully!", { position: "top-center" });
        setOriginalData(inputData);
      } else {
        toast.error("Error saving forecast", { position: "top-center" });
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("Unable to save forecast", { position: "top-center" });
    } finally {
      setIsSaving(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="forecast-card card">
          <header className="card-header">
            <h1 className="page-hero__title">Forecast Volumes</h1>
            <div className="actions">
              <button className="button ghost sm" onClick={handleReset} disabled={isSaving}>
                Reset
              </button>
              <button className="button sm" onClick={handleSaveClick} disabled={isSaving}>
                {isSaving ? "Saving…" : "Save"}
              </button>
            </div>
          </header>
          <div className="forecast-grid">
            {(() => {
              const upcoming = months.slice(currentMonthIndex);
              const past = months.slice(0, currentMonthIndex);
              const rotated = [...upcoming, ...past];
              const dividerIndex = upcoming.length - 1; // insert divider after last upcoming month
              return rotated.map((month, idx) => {
                const originalIndex = months.indexOf(month);
                const disabled = originalIndex < currentMonthIndex;
                return (
                  <React.Fragment key={month}>
                    <label className={`forecast-cell ${disabled ? "locked" : ""}`}>
                      <span>{month}</span>
                      <input
                        value={inputData[month]}
                        onChange={handleInput}
                        name={month}
                        type="number"
                        disabled={disabled}
                        placeholder="0"
                      />
                    </label>
                    {idx === dividerIndex && (
                      <div className="forecast-divider" aria-hidden="true" />
                    )}
                  </React.Fragment>
                );
              });
            })()}
          </div>
        </section>

        

        <ToastContainer />
      </main>
    </div>
  );
};

export default Forecast;
